
import React, { useState, useEffect } from "react";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { Link } from "react-router-dom";
import { Filter, Sliders, Box, Zap } from "react-feather";
import Select from "react-select";
import Axios from "axios";
import { useParams } from "react-router-dom";
// import ReactHTMLTableToExcel from "react-html-table-to-excel";
// import { jsPDF } from "jspdf";
import "jspdf-autotable";
// import * as XLSX from 'xlsx';
// import ExcelJS from "exceljs";


const PurchaseReport = () => {

  const { reportid } = useParams();
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [tableHtml, setTableHtml] = useState('');

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

    useEffect(() => {
      const postData = {
        OrgId: 41028,
        UserId: 1,
        ReportId: reportid,
        ReportCriteria: {
          FromDate: "2024-01-01",
          ToDate: "2024-12-31",
          ProductId: "0"
        }
      };
    
      // Make a POST request with axios
      Axios.post('https://ibizapi.ibizaccounts.in/report/BuildReport', postData)
        .then(response => {
          const cleanedHtml = removeScriptTags(response.data);
          setTableHtml(cleanedHtml);
          console.log('Report built successfully:', cleanedHtml);
        })
        .catch(error => {
          console.error('Error building report:', error);
        });
    }, []);

    const removeScriptTags = (html) => {
      return html.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '');
    };

  return (
    <div className="page-wrapper">
      <div className="content">
         <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>New Product</h4>
              <h6>Create new product</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li className="page-btn">
              <button className="btn border" >
                <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
              </button>
            </li>
            <li className="page-btn">
            <button className="btn border" >
                <ImageWithBasePath src="assets/img/icons/excel.svg" alt="img" />
              </button>
            </li>
            <li className="page-btn">
              <button className="btn border">
                <i className="fa-solid fa-rotate-left"></i>
              </button>
            </li>
          </ul>
        </div>
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top">
              <div className="search-set">
                <div className="search-input">
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm formsearch"
                  />
                  <Link to className="btn btn-searchset">
                    <i data-feather="search" className="feather-search" />
                  </Link>
                </div>
              </div>
              <div className="search-path">
                <Link
                  className={`btn btn-filter ${
                    isFilterVisible ? "setclose" : ""
                  }`}
                  id="filter_search"
                >
                  <Filter
                    className="filter-icon"
                    onClick={toggleFilterVisibility}
                  />
                  <span onClick={toggleFilterVisibility}>
                    <ImageWithBasePath
                      src="assets/img/icons/closes.svg"
                      alt="img"
                    />
                  </span>
                </Link>
              </div>
              <div className="form-sort stylewidth">
                <Sliders className="info-img" />

                <Select
                  className="select "
                  // options={options}
                  placeholder="Sort by Date"
                />
              </div>
            </div>
            {/* /Filter */}
            <div
              className={`card${isFilterVisible ? " visible" : ""}`}
              id="filter_inputs"
              style={{ display: isFilterVisible ? "block" : "none" }}
            >
              <div className="card-body pb-0">
                <div className="row">
                  <div className="col-lg-3">
                    <label>From</label>
                    <div className="input-blocks">
                      <input className="form-control" type="date" />
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <label>To</label>
                    <div className="input-blocks">
                      <input className="form-control" type="date" />
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <label>Store</label>
                    <div className="input-blocks">
                      <Zap className="info-img" />
                      <Select className="select"  />
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <label>Supplier</label>
                    <div className="input-blocks">
                      <Box className="info-img" />
                      <Select className="select"  />
                    </div>
                  </div>
                  <div className="col-lg-6 col-sm-6 col-12">
                    <div className="input-blocks">
                      <Link className="btn btn-filters ms-auto">
                        {" "}
                        <i
                          data-feather="search"
                          className="feather-search"
                        />{" "}
                        Search{" "}
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Filter */}
            <div className="table-responsive">
              <div dangerouslySetInnerHTML={{ __html: tableHtml }} />
            </div>
          </div>
        </div>
        {/* /product list */}
      </div>
    </div>
  );
};

export default PurchaseReport;
